<template>
  <div>
    <header-applis titre="Personnaliser l’offre à votre profil" sous-titre="La manière d’apprendre qui me correspond le plus est celle qui" index-progression-courante="3"/>
    <div class="wrapper__content app-flex-container">
      <div v-for="(valeur, index) in valeursPossibles" :key="index" class="app-flex-container-item">
        <button @click="ecranSuivant(valeur)" class="button-app big-button ">
          {{ valeur }}
        </button>
      </div>
    </div>
    <footer-applis ecran-precedent="activitesquotidiennes"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'maniereapprendre',
  components: {
    FooterApplis,
    HeaderApplis
  },
  data() {
    return {
      valeursPossibles: [
        'Se construit sur les « expériences de terrain »',
        'S’appuie sur des savoirs et de la théorie',
        'Favorise les échanges et le contact',
      ]
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  },
  methods: {
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant(valeur) {
      this.$store.commit('setManiereApprendre', valeur);
      this.$router.push('preferencesformations');
    }
  }
}
</script>

<style scoped>
.button-app {
  margin: 1rem 0;
}

.app-flex-container {
  display: flex;
  flex-wrap: wrap;
}

.app-flex-container-item {
  width: 100%;
  margin-bottom: 1.5em;
}

@media (min-width: 932px) {
  .app-flex-container-item {
    width: 30%;
    margin: 1.66%;
  }
}

#appcompetences--widget .button-app.big-button {
  width: 100%;
  height: 100%
}
</style>